import { z } from "zod";

const schema = z.object({
  candidate: z.string({ required_error: "A candidate must be selected" }),
  agreesWithScope: z.boolean().optional(),
  agreesWithBudget: z.boolean().optional(),
  agreesWithStartDate: z.boolean().optional(),
  openToFullTime: z.boolean().optional(),
  scope: z.string().optional(),
  budget: z.string().optional(),
  budgetIsFlexible: z.boolean().optional(),
  startDate: z.date().optional(),
  matchCriteria: z.string().array().optional(),
  matchCriteriaQuote: z.string().array().optional(),
  personalityRoleStrength: z.string().optional(),
  personalityRoleStrengthDetail: z.string().optional(),
  behaviorRoleStrength: z.string().optional(),
  behaviorRoleStrengthDetail: z.string().optional(),
  motivatorRoleStrength: z.string().optional(),
  motivatorRoleStrengthDetail: z.string().optional(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as adminAddCandidateToJobFormSchema,
  type Schema as AdminAddCandidateToJobFormSchema,
};
